import styled from "styled-components";

export const SubjectsDashboardContainer = styled.div`
	min-height: 100vh;

	.img_text_odd_even {
		padding: 60px 0;
		background: #f8f9fa;
	}

	.redfont {
		color: #e74c3c;
	}

	@media (max-width: 991px) {
		.img_text_odd_even {
			padding: 40px 0;
		}
	}
`;
